/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteReadReqVo
 */
export interface NoteReadReqVo {
    /**
     * 站内信ID列表
     * @type {Array<number>}
     * @memberof NoteReadReqVo
     */
    ids: Array<number>;
    /**
     * 接收者ID
     * @type {number}
     * @memberof NoteReadReqVo
     */
    receiverId: number;
}

/**
 * Check if a given object implements the NoteReadReqVo interface.
 */
export function instanceOfNoteReadReqVo(value: object): value is NoteReadReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('receiverId' in value) || value['receiverId'] === undefined) return false;
    return true;
}

export function NoteReadReqVoFromJSON(json: any): NoteReadReqVo {
    return NoteReadReqVoFromJSONTyped(json, false);
}

export function NoteReadReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteReadReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'receiverId': json['receiverId'],
    };
}

export function NoteReadReqVoToJSON(json: any): NoteReadReqVo {
    return NoteReadReqVoToJSONTyped(json, false);
}

export function NoteReadReqVoToJSONTyped(value?: NoteReadReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'receiverId': value['receiverId'],
    };
}

